import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import ViewportType from '../../../shared/enums/viewport-type.enums';

@Component({
  selector: 'hdi-bubble',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './bubble.component.html',
  styleUrl: './bubble.component.scss',
  host: {
    id: crypto.randomUUID().toString(),
  },
})
export class BubbleComponent {
  @Input() viewport: ViewportType = ViewportType.desktop;
  @Input() label?: string;
}
